<template>
    <button
        type="button"
        @click="click"
        class="inline-flex items-center rounded-full bg-black text-center text-sm font-medium text-white shadow-xl hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-300"
        :class="noPadding ? 'p-0':'p-2 md:p-4'"
    >
        <span class="material-symbols-outlined">
            {{icon}}
        </span>
        <span class="sr-only">{{name}}</span>
    </button>
</template>

<script>
export default {
    name: "AtomIconButton",
    props: {
        icon: {
            type: String,
            required: true
        },
        name:{
            type: String,
            required: false
        },
        noPadding: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        click(){
            this.$emit('click')
        }
    }
}
</script>

<style scoped>

</style>
